import { hasAnonymousParam } from 'owa-config/lib/anonymousUtils';
import { redirectToAuthenticatedRoute } from 'owa-config/lib/redirectToAuthenticatedRoute';
import { ATTENDEE_PAGE_KEYWORD } from 'bookwithme-shared/lib/store/schema/BookWithMeRouteConstants';
import { isAnonymousUser } from 'bookings-shared/lib/c2/utils/isAnonymousUser';
import { isMsalEnabledForBusiness } from 'owa-msaljs/lib/isMsalEnabledForBusiness';
import { logUsage } from 'owa-analytics';
import { handleFallbackScenariosForMSALAnonymous } from 'owa-msaljs/lib/utils/handleFallbackScenariosForMSALAnonymous';

export default function runBeforeStart(): Promise<void> {
    // If the anonymous param is present, we need to check if we should re-route to the authenticated route.
    // We want to do this in 2 situations:
    // 1. The user is not anonymous (authenticated via another app)
    // 2. The user is attempting to access anything but the attendee page anonymously.
    // For #1, we reroute to give the user a fully authenticated experience since we already know who they are.
    // For #2, we reroute to enforce authentication as there's no supported anonymous scenario other than voting.

    const isAttendeePage = window.location.pathname.indexOf(ATTENDEE_PAGE_KEYWORD) > -1;

    if (!areMSALFlightsEnabled()) {
        /*
        If it is an attendee page and the user is not anonymous, we don't need to redirect to authenticated route
        */
        if (isAttendeePage && !isAnonymousUser()) {
            return Promise.resolve();
        }

        if (hasAnonymousParam() && (!isAnonymousUser() || !isAttendeePage)) {
            /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
             * BASELINE: DO NOT COPY/PASTE!
             *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
            logUsage(
                /* eslint-disable-next-line owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
                 * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
                 *	> Invalid Outlook telemetry EventName "redirectToAuthenticatedRouteBwm": must start with a capital letter (A–Z). */
                'redirectToAuthenticatedRouteBwm',
                undefined
            );
            redirectToAuthenticatedRoute();
        }
    }

    if (isAttendeePage) {
        handleFallbackScenariosForMSALAnonymous();
    }

    return Promise.resolve();
}

function areMSALFlightsEnabled(): boolean {
    return isMsalEnabledForBusiness();
}
